document.addEventListener('DOMContentLoaded', function () {
    let uspSwipers = [];

    function initUspSwipers() {
        const screenWidth = window.innerWidth;

        if (screenWidth < 1100 && uspSwipers.length === 0) {
            document.querySelectorAll('.usp-swiper').forEach(el => {
                const swiper = new Swiper(el, {
                    loop: false,
                    simulateTouch: true,
                    slidesPerView: 1,
                    spaceBetween: 24,
                    autoplay: {
                        delay: 4000
                    }
                });
                uspSwipers.push(swiper);
            });
        } else if (screenWidth >= 1100 && uspSwipers.length > 0) {
            uspSwipers.forEach(swiper => {
                swiper.destroy(true, true);
            });
            uspSwipers = [];
        }
    }

    initUspSwipers();
    window.addEventListener('resize', initUspSwipers);
});